import Grid from "@mui/material/Grid2";
import DataStoreRequestTable from "../DataStoreRequestTable/DataStoreRequestTable";
import { Paper, Typography } from "@mui/material";
import DataStoreRequestFilterCard from "../DataStoreFilter/DataStoreRequestFilterCard";
import SimpleBackdrop from "../../../BackDrop/BackDrop";
import { useSelector } from "react-redux";

const DataStoreRequestBase = () => {
  const tableHeadings = {
    id: "ID",
    name: "Query Name",
    database: "Database",
    type: "Type",
    modules: "Modules",
    modified_by: "Modified By",
    modified: "Modified On",
    quick_actions: "Quick Actions",
  };

  const isLoading = useSelector((state: any) => state.dataStoreReq.isLoading);

  return (
    <>
      <Paper>
        <Grid container alignItems="center" sx={{ p: 2 }}>
          <Grid size={12} mb={2}>
            <Typography variant="h3" sx={{ fontSize: "24px" }}>
              Queries
            </Typography>
            <Typography variant="body2" sx={{ fontSize: "14px" }}>
              Create, edit and manage business queries stored in database.
            </Typography>
          </Grid>
          <DataStoreRequestFilterCard />
        </Grid>
        {isLoading ? (
          <SimpleBackdrop />
        ) : (
          <DataStoreRequestTable tableHeadings={tableHeadings} />
        )}
      </Paper>
    </>
  );
};

export default DataStoreRequestBase;
